import { Language } from './translations'

export interface CaseStudy {
  id: string
  company: string
  logo: string
  /** Hauteur du logo (classes Tailwind), utile pour les logos empilés */
  logoClassName?: string
  photo?: string
  /** Texte alternatif de la photo ; « Magasin <entreprise> » par défaut */
  photoAlt?: Record<Language, string>
  objective: Record<Language, string>
  /** Libellé du bloc de contexte ; « Contexte » par défaut */
  contextLabel?: Record<Language, string>
  context: Record<Language, string>
  quote?: {
    before: Record<Language, string>
    strong: Record<Language, string>
    after: Record<Language, string>
  }
  author?: {
    name: string
    initials: string
    /** Photo de la personne ; à défaut, ses initiales sont affichées */
    avatar?: string
    role: Record<Language, string>
  }
}

export const caseStudies: CaseStudy[] = [
  {
    id: 'leclerc',
    company: 'E.Leclerc',
    logo: 'https://cdn.magicpatterns.com/uploads/rudCk7onz7Z5rnBTJJCbjY/Leclerc.png',
    photo: 'https://cdn.magicpatterns.com/uploads/6eR2oS67SLZKCxgv7WfptL/Capture_d’ecran_2026-10-22_a_12.38.11.png',
    photoAlt: {
      fr: 'Collaborateur E.Leclerc souriant dans les rayons du magasin',
      en: 'Smiling E.Leclerc employee in the store aisles'
    },
    objective: {
      fr: "Améliorer l'engagement et réduire le turnover",
      en: 'Improve engagement and reduce turnover'
    },
    context: {
      fr: '160 collaborateurs dont 22 managers',
      en: '160 employees, including 22 managers'
    },
    quote: {
      before: {
        fr: 'Dès les premiers parcours, nous avons constaté un ',
        en: 'From the very first programs, we saw '
      },
      strong: {
        fr: 'réel intérêt',
        en: 'genuine interest'
      },
      after: {
        fr: ' de la part des collaborateurs et des managers.',
        en: ' from both employees and managers.'
      }
    },
    author: {
      name: 'Laurent Gherardi',
      initials: 'LG',
      avatar: 'https://cdn.magicpatterns.com/uploads/dhGc1Jv6pWeUV2atkPftu8/Capture_d’ecran_2026-10-22_a_13.56.43.png',
      role: { fr: 'Adhérent Leclerc', en: 'Leclerc store owner' }
    }
  },
  {
    id: 'partenord',
    company: 'Partenord Habitat',
    logo: 'https://cdn.magicpatterns.com/uploads/sdH11Gu4akGypToWazL4it/logo-partenord-habitat.webp',
    logoClassName: 'h-12 sm:h-14',
    photo: 'https://cdn.magicpatterns.com/uploads/84sTZwthEum6q6S6yqzoad/Partenord-perspective-ilot5-scaled.jpg',
    photoAlt: {
      fr: 'Perspective des bâtiments Partenord Habitat entourés de jardins',
      en: 'Rendering of Partenord Habitat buildings surrounded by gardens'
    },
    objective: {
      fr: "Piloter l'engagement à grande échelle",
      en: 'Steer engagement at scale'
    },
    contextLabel: {
      fr: 'Périmètre',
      en: 'Scope'
    },
    context: {
      fr: '900 collaborateurs dont 75 managers',
      en: '900 employees, including 75 managers'
    },
    quote: {
      before: {
        fr: 'La collaboration avec Rewayz nous a permis de ',
        en: 'Working with Rewayz has helped us '
      },
      strong: {
        fr: 'franchir un cap décisif',
        en: 'take a decisive step forward'
      },
      after: {
        fr: " dans l'accompagnement de nos managers.",
        en: ' in how we support our managers.'
      }
    },
    author: {
      name: 'Matthieu Canda',
      initials: 'MC',
      role: { fr: 'Directeur Ressources Humaines', en: 'HR Director' }
    }
  },
  {
    id: 'wyz-group',
    company: 'WYZ group',
    logo: 'https://cdn.magicpatterns.com/uploads/s1PQA9HmLaM2BAPLcrnghc/WYZ-Group-Logo.webp',
    logoClassName: 'h-10 sm:h-12',
    photo: 'https://cdn.magicpatterns.com/uploads/mqriZu25S15hHwVGuZr5Wk/Rectangle-2.png.webp',
    photoAlt: {
      fr: 'Technicien souriant avec une tablette dans un atelier automobile',
      en: 'Smiling technician holding a tablet in a car workshop'
    },
    objective: {
      fr: "Maintenir l'engagement dans la durée",
      en: 'Sustain engagement over time'
    },
    contextLabel: {
      fr: 'Périmètre',
      en: 'Scope'
    },
    context: {
      fr: '70 collaborateurs dont 10 managers',
      en: '70 employees, including 10 managers'
    },
    quote: {
      before: {
        fr: 'Je vois dans le Copilote Rewayz un ',
        en: 'I see the Rewayz Copilot as a '
      },
      strong: {
        fr: 'véritable levier de structuration et de montée en compétence',
        en: 'real lever for structuring and upskilling'
      },
      after: {
        fr: ' de nos managers.',
        en: ' our managers.'
      }
    },
    author: {
      name: 'Adeline Macke',
      initials: 'AM',
      avatar: 'https://cdn.magicpatterns.com/uploads/3Cr3Yr3Dx7bKk77KbhMcYY/Capture_d’ecran_2026-10-22_a_13.49.45.png',
      role: { fr: 'Directrice Ressources Humaines', en: 'HR Director' }
    }
  }
]
